<template lang="pug">

    .ui.active.page.dimmer
        .ui.text.primary.elastic.loader {{ text }}

</template>

<script>
    import delay from 'lodash/delay'

    export default {

        created() {
            this.$auth.logout()
            delay(() => this.text = 'Qapla’', 1995)
            delay(() => location.reload(), 2000)
        },

        data() {
            return {
                text: 'Abmelden...'
            }
        }

    }

</script>

